module.exports = __webpack_public_path__ + "img/1463648278.fce57548.jpg";